import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import Spoiler from "../../user_content/spoiler";
import TruncatedHtml from "../../user_content/truncated_html";
import UserProfileLink from "../../user/user_profile_link";

export default GrComponentFactory.createClass({
  displayName: "CommunityAnswerDetails",

  propTypes: GrPropTypes.communityAnswer(),

  renderAnswerSpoilerWarning() {
    return (
      <span className="communityQANewsfeedItem__spoilerWarning">
        This answer contains spoilers…
      </span>
    );
  },

  renderQuestionSpoilerWarning() {
    return (
      <span className="communityQANewsfeedItem__spoilerWarning">
        This question contains spoilers…
      </span>
    );
  },

  renderAnswerText() {
    const answerText = <TruncatedHtml {...this.props.answerText}/>;
    return (
      <div className="communityQANewsfeedItem__answerText">
        {
          this.props.isSpoiler ?
            <Spoiler spoilerWarning={this.renderAnswerSpoilerWarning()}>
              {answerText}
            </Spoiler>
            :
            answerText
        }
      </div>
    );
  },

  renderQuestionText() {
    const communityQuestion = this.props.communityQuestion;
    return (
      <div className="communityQANewsfeedItem__questionText">
        {
          communityQuestion.isSpoiler ?
            <Spoiler html={communityQuestion.questionText} spoilerWarning={this.renderQuestionSpoilerWarning()}/>
            :
            communityQuestion.questionText
        }
      </div>
    );
  },

  renderQuestion() {
    return (
      <div className="communityQANewsfeedItem__question">
        <UserProfileLink user={this.props.communityQuestion.user} /> asked:
        {this.renderQuestionText()}
      </div>
    );
  },

  render() {
    return (
      <div>
        {this.renderAnswerText()}
        {this.renderQuestion()}
      </div>
    );
  },
});
